<div mat-dialog-content>
  <iframe
  class="iframe"
    width="610px"
    height="312px"
    src="https://crm.zoho.in/crm/WebFormServeServlet?rid=fc65f277c4e81f6333ad800b72ca546ee47c1ea5675964cd456cd1a0c8032331gid226260fedf5402676c60581b4a97c9f537a81295207976b05e423762d0283757"
  ></iframe>
</div>
<div mat-dialog-actions>
  <button mat-button class="close" (click)="onNoClick()" cdkFocusInitial>
    Close
  </button>
</div>
